module.exports = __webpack_public_path__ + "img/girl.8b81b4b9.png";